import { TransactionItem } from "./TransactionItem";
import type { ITransaction } from "../interfaces/transactions";
import { Trans, useTranslation } from "react-i18next";
import { APP_ROUTES } from "../constants";
import { useRouteWithToken } from "../hooks/useRouteWithToken";
import { safeCapture } from "../utils/posthog";
import { BodyCopy } from "lola-framework-ui-test";
export interface TransactionsHistoryProps {
  items: unknown[];
}

export const TransactionsHistory: React.FC<TransactionsHistoryProps> = ({
  items = [],
}) => {
  const { t } = useTranslation();
  const { redirectTo } = useRouteWithToken();
  const isEmpty = items.length === 0;

  const handleTransactionClick = (operationId: string) => {
    const item = (items as ITransaction[]).find(
      (t) => t.operationId === operationId
    );
    safeCapture("ui.home.transactions.transaction_item.select", {
      operation_id: operationId,
      status: item?.status,
    });
    redirectTo(
      `${APP_ROUTES.RECEIPT_SUMMARY_PAGE.replace(":operationId", operationId)}`
    );
  };

  return (
    <>
      <BodyCopy
        className="normal-text foreground text-left"
        style={{ marginBlock: "24px", paddingLeft: 12 }}
      >
        <b>{t("transactions.title")}</b>
      </BodyCopy>
      <section className="transactions-history-container">
        {isEmpty ? (
          <section className="transactions-history-empty">
            <p className="empty-title foreground">
              <b>
                <Trans i18nKey="transactions.emptyTitle" />
              </b>
              {/* <b>{t("transactions.emptyTitle")}</b> */}
            </p>
            <p className="empty-description muted-foreground">
              <Trans i18nKey="transactions.emptyDescription" />
              {/* {t("transactions.emptyDescription")} */}
            </p>
          </section>
        ) : (
          <section className="transactions-history-list">
            {items.map((transaction, index) => (
              <TransactionItem
                key={index}
                {...(transaction as ITransaction)}
                onClick={handleTransactionClick}
              />
            ))}
          </section>
        )}
      </section>
    </>
  );
};
